import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const AdminRoute = ({
  component: Component,
  user,
  profile,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (!user || !user.id) {
        return <Redirect to="/login" />;
      }

      if (profile.userType !== 1) {
        return <Redirect to="/home" />;
      }

      return <Component {...props} />;
    }}
  />
);

export default connect((state) => ({
  profile: state.profile.profile,
  user: state.user,
}))(AdminRoute);
